// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';

export const updateListFilterBy = (filterString, state) =>
    ({
        data: filterString,
        state,
        type: actions.UPDATE_LIST_FILTER_BY
    });

export const updateListSortBy = (sortPath, state) =>
    ({
        data: sortPath,
        state,
        type: actions.UPDATE_LIST_SORT_BY
    });

export const updateListSortDirection = (direction, state) =>
    ({
        data: direction,
        state,
        type: actions.UPDATE_LIST_SORT_DIRECTION
    });



// WEBPACK FOOTER //
// ./src/shared/action-creators/refine-list.js